<template>
	<div>
		<div class="btnbox boxDw" @click="pickerVisible = true">
			打开picker
			<!-- <div class="btn" @click="toCopy">复制demo代码</div> -->
		</div>
		<!-- <div class="result"> -->
			<!-- <p>选择结果</p> -->
			<!-- <p>{{result}}</p> -->
		<!-- </div> -->
		<VuePicker :data="pickData" :layer="3" :showToolbar="true" @cancel="cancel" @confirm="confirm"
			:visible.sync="pickerVisible" />
	</div>
</template>

<script>
	let _self;
	import VuePicker from 'vue-pickers'
	// import copy from 'copy-to-clipboard'
	// import copyText from '@/copy/address.js'
	import cityData from 'vue-pickers/city-data.js'
	const deepFreeze = function(obj) {
		var propNames = Object.getOwnPropertyNames(obj);
		propNames.forEach(function(name) {
			var prop = obj[name];
			if (typeof prop == 'object' && prop !== null) {
				deepFreeze(prop);
			}
		})
		return Object.freeze(obj)
	}
	// 冻结以提升性能
	const freezeCityData = deepFreeze(cityData)
	export default {
		name: 'app',
		components: {
			VuePicker
		},
		data() {
			return {
				showToolbar: true,
				pickerVisible: false,
				pickData: freezeCityData,
				result: ''
			}
		},
		beforeCreate() {
			_self=this;
		},
		methods: {
			cancel() {
				// console.log('cancel')
				this.result = 'click cancel result: null'
			},
			confirm(res) {
				let obj = JSON.parse(JSON.stringify(res))
				if (obj[0].children) {
					delete obj[0].children
				}
				if (obj[1].children) {
					delete obj[1].children
				}
				if (obj[2].children) {
					delete obj[2].children
				}
				this.result = JSON.stringify(obj)
				// console.log('11111111111',res)
				// 输出选择好的地址
				_self.$emit('selAddress',res)
			},
			toCopy() {
				copy(copyText)
				this.$emit('tips')
			}
		}
	}
</script>
<style scoped="scoped">
	.boxDw{
		position: absolute;
		width: 100%;
		height: 100%;
	}
</style>